<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row
    class="content"
    routerLink="/app/report/report-config/edit-report-config/{{ row.id }}"
  >
    <ion-col size="2">{{ row.name }}</ion-col>
    <ion-col size="2">{{
      row.system ? dictionaryService.systemName(row.system) : ""
    }}</ion-col>
    <ion-col size="2">
      <div class="ion-text-center">
        <ion-icon
          size="large"
          *ngIf="row.sendEmail"
          name="checkmark-circle-outline"
          color="success"
        ></ion-icon>
        <ion-icon
          size="large"
          *ngIf="!row.sendEmail"
          name="remove-circle-outline"
          color="danger"
        ></ion-icon>
      </div>
    </ion-col>

    <ion-col size="2">
      <div class="ion-text-center">
        <ion-icon
          size="large"
          *ngIf="row.sendSms"
          name="checkmark-circle-outline"
          color="success"
        ></ion-icon>
        <ion-icon
          size="large"
          *ngIf="!row.sendSms"
          name="remove-circle-outline"
          color="danger"
        ></ion-icon>
      </div>
    </ion-col>

    <ion-col size="2">
      <div class="ion-text-center">
        <ion-icon
          size="large"
          *ngIf="row.sendNotification"
          name="checkmark-circle-outline"
          color="success"
        ></ion-icon>
        <ion-icon
          size="large"
          *ngIf="!row.sendNotification"
          name="remove-circle-outline"
          color="danger"
        ></ion-icon>
      </div>
    </ion-col>

    <ion-col size="2">
      <div class="ion-text-center">
        <ion-icon
          size="large"
          *ngIf="row.autoGenReportTask"
          name="checkmark-circle-outline"
          color="success"
        ></ion-icon>
        <ion-icon
          size="large"
          *ngIf="!row.autoGenReportTask"
          name="remove-circle-outline"
          color="danger"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/report/report-config/edit-report-config/{{ row.id }}"
>
  <ion-card-content class="mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col>
          <ion-text class="txt-info">{{ row.name }}</ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-header *ngIf="row.category">
    <ion-card-subtitle>
      {{ "REPORT_CONFIG.SYSTEM" | translate }}
    </ion-card-subtitle>
    <ion-card-title>{{
      dictionaryService.systemName(row.system)
    }}</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col size-xs="12" size-sm="3">
          <div class="config-icon-container">
            <div class="config-icon">
              {{ "REPORT_CONFIG.SEND_EMAIL" | translate }}
            </div>
            <div class="config-icon">
              <ion-icon
                size="large"
                *ngIf="row.sendEmail"
                name="checkmark-circle-outline"
                color="success"
              ></ion-icon>
              <ion-icon
                size="large"
                *ngIf="!row.sendEmail"
                name="remove-circle-outline"
                color="danger"
              ></ion-icon>
            </div>
          </div>
        </ion-col>

        <ion-col size-xs="12" size-sm="3">
          <div class="config-icon-container">
            <div class="config-icon">
              {{ "REPORT_CONFIG.SEND_SMS" | translate }}
            </div>
            <div class="config-icon">
              <ion-icon
                size="large"
                *ngIf="row.sendSms"
                name="checkmark-circle-outline"
                color="success"
              ></ion-icon>
              <ion-icon
                size="large"
                *ngIf="!row.sendSms"
                name="remove-circle-outline"
                color="danger"
              ></ion-icon>
            </div>
          </div>
        </ion-col>

        <ion-col size-xs="12" size-sm="3">
          <div class="config-icon-container">
            <div class="config-icon">
              {{ "REPORT_CONFIG.SEND_NOTIFICATION" | translate }}
            </div>
            <div class="config-icon">
              <ion-icon
                size="large"
                *ngIf="row.sendNotification"
                name="checkmark-circle-outline"
                color="success"
              ></ion-icon>
              <ion-icon
                size="large"
                *ngIf="!row.sendNotification"
                name="remove-circle-outline"
                color="danger"
              ></ion-icon>
            </div>
          </div>
        </ion-col>

        <ion-col size-xs="12" size-sm="3">
          <div class="config-icon-container">
            <div class="config-icon">
              {{ "REPORT_CONFIG.AUTO_GENERATE_TASK" | translate }}
            </div>
            <div class="config-icon">
              <ion-icon
                size="large"
                *ngIf="row.autoGenReportTask"
                name="checkmark-circle-outline"
                color="success"
              ></ion-icon>
              <ion-icon
                size="large"
                *ngIf="!row.autoGenReportTask"
                name="remove-circle-outline"
                color="danger"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
